<template>
  <div class="wxGroupContact wv100 hv100">
    <!-- 标签 -->
    <div class="labelDiv">
      <div class="labelDivSe">
        <van-search
          v-model="keyWord"
          @search="keyWSearch"
          @cancel="keyWCancel"
          @input="keyWInput"
          placeholder="请输入搜索关键词"
        />
      </div>
    </div>
    <van-divider />
    <!-- 全选 -->
    <div class="h44 bg-ff selectAllDiv">
      <van-checkbox
        :disabled="multiSelect == 0 ? false : true"
        v-model="seleclAll"
        @click="seleclAllChange"
        >全部选择</van-checkbox
      >
    </div>
    <van-divider />
    <van-checkbox-group class="" v-model="selectResult">
      <van-cell-group class="listBarB">
        <listScroll
          :listData="userList"
          :loadEnd="loadEnd"
          :loadEndText="loadEndText"
          @loadNext="getwxExuser"
          ref="listScrollCP"
        >
          <template v-slot:itemRow="itemData">
            <van-cell @click="toggle('checkboxes' + itemData.item.id)">
              <!-- <van-cell> -->
              <template #title>
                <div class="exUserItem">
                  <div class="exUserItemAc">
                    <van-checkbox
                      :name="itemData.item.id"
                      :ref="'checkboxes' + itemData.item.id"
                      @change="itemChange"
                    >
                    </van-checkbox>
                  </div>
                  <div class="exUserItemIm">
                    <van-image
                      width="40"
                      height="40"
                      fit="cover"
                      :src="
                        itemData.item.avatar && itemData.item.avatar.length > 0
                          ? item.avatar
                          : 'img/face.png'
                      "
                    />
                  </div>
                  <div class="exUserItemTx">
                    <p class="name">
                      {{ itemData.item.name }}
                      <span class="wxTx"
                        >@{{ itemData.item.department_names }}</span
                      >
                    </p>
                  </div>
                </div>
              </template>
            </van-cell>
            <van-divider />
          </template>
        </listScroll>
      </van-cell-group>
    </van-checkbox-group>
    <!-- 结果 -->
    <div class="resultDiv">
      <van-divider />
      <div class="resultDivImAc">
        <div class="resultDivIm">
          <van-image
            v-for="(item, index) in selectUser"
            @click="delSelectUser(item)"
            :key="index"
            width="40px"
            height="40px"
            fit="cover"
            :src="
              item.avatar && item.avatar.length > 0
                ? item.avatar
                : 'img/face.png'
            "
          />
        </div>
        <div class="resultDivAc">
          <van-button type="info" size="small" @click="wxExcomfireSelect">
            <template v-if="selectUser.length > 0">
              确定({{ selectUser.length }})
            </template>
            <template v-else>返回</template>
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import listScroll from "../listScroll";
export default {
  props: {
    initUser: Array,
    getDataUrl: String,
    getInitDataUrl: String,
    labelUrl: String,
    upDateUserUrl: {
      type: String,
      default: ""
    },
    multiSelect: {
      type: Number,
      default: 0
    },
    type: String
  },
  data() {
    return {
      indexList: [],
      userList: [],
      selectUser: [],
      lableValue: "",
      // lableList: [{ text: "全部标签", value: "" }],
      lableList: [],
      seleclAll: false,
      sticky: false,
      keyWord: "",
      selectResult: [],
      loadEnd: false,
      page: 1,
      page_size: 200,
      loading: false,
      loadEndText: "",
      lableListResult: [],
      lableListResultTitle: "全部标签",
      selectAllTag: false,
      isLableListResultChange: false,
      lastParameter: {
        closeUnSet: false,
        lableListResult: [],
        lableListResultTitle: ""
      },
      lableGroup: {}
    };
  },
  watch: {
    selectResult() {
      this.changeSelectAllType();
      this.setSelectUser();
    },
    selectAllTag(n) {
      if (n) {
        this.lableListResult = [];
        this.lableList.forEach(item => {
          this.lableListResult.push(item.value);
        });
      } else {
        if (!this.isLableListResultChange) {
          this.lableListResult = [];
        }
      }
    },
    lableListResult(n) {
      if (n.length == this.lableList.length) {
        this.selectAllTag = true;
      } else {
        this.selectAllTag = false;
      }
    }
  },
  components: {
    listScroll
  },
  async mounted() {},
  methods: {
    toggleTag(index) {
      this.isLableListResultChange = true;
      this.$refs.checkboxesTag[index].toggle();
    },
    keyWCancel() {
      this.keyWord = "";
      this.page = 1;
      this.getwxExuser();
    },
    keyWSearch(key) {
      this.keyWord = key;
      this.page = 1;
      this.getwxExuser();
    },
    keyWInput(key) {
      if (key.trim().length === 0) {
        this.keyWord = "";
        this.page = 1;
        this.getwxExuser();
      }
    },
    lableChange() {
      this.page = 1;
      this.getwxExuser();
    },
    // 获取外部联系人
    async getwxExuser() {
      if (this.loading === true) {
        return;
      }
      this.loading = true;
      let resData = await this.$common.http({
        url: this.getDataUrl,
        data: {
          page: this.page,
          page_size: this.page_size,
          id: this.lableGroup.id,
          keyword: this.keyWord
        }
      });
      let userList = resData.data.data.items;
      if (this.page === 1) {
        this.loadEnd = false;
        this.userList = userList;
      } else {
        userList.forEach(i => {
          this.userList.push(i);
        });
      }
      let indexList = [];
      let indexListUserId = [];

      this.userList.forEach(i => {
        // indexList.push(i.first_py);
        indexListUserId.push(i.id);
        // i.index = index.toString();
        // if (
        //   !this.userList[Number(index - 1)] ||
        //   i.first_py != this.userList[Number(index) - 1].first_py
        // ) {
        //   i.first_py_show = true;
        // } else {
        //   i.first_py_show = false;
        // }
      });

      // 第一次调用
      if (this.page == 1) {
        // 由于是一次性加载数据，缓存一次，用于统计选择人员
        // this.userListAll = JSON.parse(JSON.stringify(this.userList));
        // 索引数组
        this.indexList = Array.from(new Set(indexList));
        // 选中数据数据
        // this.setSelectUser();
        // 回调调组件
        // this.$emit("wxExcomfireSelect", this.selectUser);
      }
      // 过滤已选择数据中不包含在当前返回的数据
      let selectResult = [];
      this.selectResult.forEach(i => {
        if (indexListUserId.indexOf(i) >= 0) {
          selectResult.push(i);
        }
      });
      this.selectResult = selectResult;
      // 全选按钮控制
      this.changeSelectAllType();
      this.loading = false;
      this.page += 1;
      if (resData.data.data.items.length < this.page_size) {
        this.loadEnd = true;
        this.loadEndText =
          "共" + this.userList.length + "条数据，没有更多内容啦~";
      }
    },
    setSelectUser() {
      this.selectUser = [];
      this.userList.forEach(i => {
        if (this.selectResult.indexOf(i.id.toString()) >= 0) {
          this.selectUser.push(i);
        }
      });
    },
    // 获取标签数据接口
    getLebalData() {
      return this.$common.http({
        url: this.labelUrl,
        data: { type: this.type },
        noLoading: true
      });
    },
    // 确认选择
    wxExcomfireSelect() {
      if (this.multiSelect != 0 && this.selectUser.length > 1) {
        this.$common.mbToastFail("最多只能选择一个人员");
        return;
      }
      this.$emit("wxExcomfireSelect", this.selectUser);
    },
    // 全选改变
    seleclAllChange() {
      this.selectResult = [];
      if (this.seleclAll) {
        this.userList.forEach(i => {
          this.selectResult.push(i.id);
        });
      }
    },
    // 其他值改变时，全选状态变动
    changeSelectAllType() {
      let count = 0;
      this.userList.forEach(i => {
        if (this.selectResult.indexOf(i.id.toString()) >= 0) {
          count++;
        }
      });
      if (count === this.userList.length && this.userList.length != 0) {
        this.seleclAll = true;
      } else {
        this.seleclAll = false;
      }
    },
    itemChange(type, id) {
      console.log(type, id);
    },
    toggle(index) {
      // debugger;
      // console.log(index)
      // return;
      this.$refs[index].toggle();
    },
    listScrollRe() {
      this.$refs.listScrollCP.pRefresh();
    },
    // 获取初始化数据
    getInitData() {
      this.$common
        .http({
          url: this.getInitDataUrl,
          data: {
            users: this.initUser
          }
        })
        .then(res => {
          console.log(res);
        });
    },
    toggleTagAll() {
      this.isLableListResultChange = false;
      this.$refs["toggleTagAll"].toggle();
    },
    onConfirm() {
      if (this.lableListResult.length == this.lableList.length) {
        this.lableListResultTitle = "全部标签";
      } else {
        let lableListResultTitleArr = [];
        this.lableListResult.forEach(item => {
          for (let i in this.lableList) {
            let itemO = this.lableList[i];
            if (itemO.value == item) {
              lableListResultTitleArr.push(itemO.text);
              break;
            }
          }
        });
        this.lableListResultTitle =
          lableListResultTitleArr.length > 0
            ? lableListResultTitleArr.join(",")
            : "无选中标签";
      }
      this.page = 1;
      this.getwxExuser();
      this.lastParameter.closeUnSet = true;
      this.$refs.dropdownItem.toggle();
    },
    dropdownItemOpen() {
      this.lastParameter = {
        closeUnSet: false,
        lableListResult: this.lableListResult,
        lableListResultTitle: this.lableListResultTitle
      };
    },
    dropdownItemClose() {
      if (!this.lastParameter.closeUnSet) {
        this.isLableListResultChange = true;
        this.lableListResult = this.lastParameter.lableListResult;
        this.lableListResultTitle = this.lastParameter.lableListResultTitle;
      }
    },
    upDateUser() {
      this.$common
        .http({
          url: this.upDateUserUrl,
          data: {}
        })
        .then(res => {
          if (Number(res.data.errcode) == 0) {
            this.$common.mbToastSuccess(res.data.message);
          }
        });
    },
    delSelectUser(item) {
      let delIndex = "";
      this.selectResult.forEach((element, index) => {
        if (element == item.id) {
          delIndex = index;
        }
      });
      if (delIndex != "") {
        this.selectResult.splice(delIndex, 1);
      }
    }
  },
  async created() {
    console.log(this);
    this.selectResult = this.initUser;
    const lableGroupRes = await this.getLebalData();
    this.lableGroup = lableGroupRes.data.data;
    this.getwxExuser();
    if (this.selectResult.length > 0) {
      this.getInitData();
    }
  }
};
</script>
<style lang="less">
.wxGroupContact {
  position: absolute;
  left: 0;
  top: 0;
  background-color: #f4f4f4;
  overflow: hidden;
  z-index: 100;
  .h44 {
    height: 44px;
  }
  .bg-ff {
    background-color: #ffffff;
  }
  .van-divider {
    margin: 0;
  }
  .labelDiv {
    display: flex;
    padding-right: 10px;
    background-color: #ffffff;
    .labelDivSe {
      width: 100%;
    }
    .labelDivDe {
      width: 95px;
      box-sizing: border-box;
      .van-ellipsis {
        width: 60px;
        font-size: 14px;
      }
    }
  }
  .selectAllDiv {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 16px;
    .upDateUser {
      padding-right: 16px;
      color: #1989fa;
    }
  }
  .van-dropdown-menu__bar {
    height: 54px;
    box-shadow: none;
  }
  .van-dropdown-menu__item {
    justify-content: center;
  }
  .van-dropdown-menu__title {
    padding-left: 0;
  }
  .van-index-anchor {
    text-align: left;
    background: #f4f4f4;
  }
  .listBarB {
    height: calc(100vh - 100px);
    overflow: hidden;
    padding-bottom: 70px;
    box-sizing: border-box;
  }
  .listBar {
    height: calc(100vh - 120px);
    overflow: auto;
    padding-bottom: 70px;
    box-sizing: border-box;
    background: #f4f4f4;
  }
  .exUserItem {
    display: flex;
    align-items: center;
    line-height: normal;
    .exUserItemAc {
    }
    .exUserItemIm {
      margin-left: 10px;
    }
    .exUserItemTx {
      width: calc(100vw - 110px);
      margin-left: 10px;
      p {
        margin: 0;
        padding-bottom: 2px;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .name {
        text-align: left;
        line-height: 14px;
      }
      .label {
        .van-tag {
          margin-right: 2px;
        }
      }
    }
  }
  .resultDiv {
    position: fixed;
    width: 100vw;
    bottom: -1px;
    left: 0;
    height: 64px;
    background-color: #ffffff;
    box-sizing: border-box;
    .resultDivImAc {
      display: flex;
      align-items: center;
      padding: 11px 16px 0px 16px;
      padding-top: 11px;
    }
    .resultDivIm {
      width: calc(100vw - 120px);
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      text-align: left;
      height: 44px;
      .van-image {
        margin-right: 3px;
        display: inline-block;
      }
    }
    .resultDivAc {
      width: 120px;
      padding-left: 16px;
      .van-button--small {
        font-size: 14px !important;
        width: 95px;
      }
    }
  }
  .emptyData {
    color: #a4a4a4;
  }
  .van-index-bar__index--active {
    color: #1989fa;
  }
  .wxTx {
    font-size: 12px;
    color: #07c160;
    padding-left: 2px;
  }
  .qyWxTx {
    font-size: 12px;
    color: #ee0a24;
    padding-left: 2px;
  }
  .indexAnchor {
    line-height: 20px;
    font-size: 14px;
    padding-left: 16px;
    display: inline-block;
    width: 100%;
    text-align: left;
    background: #f4f4f4;
  }
  .van-cell__title {
    text-align: left;
  }
  .van-dropdown-menu__title--active {
    color: #1989fa !important;
  }
}
</style>
